/**
 * orga-app-api - veranstaltungstypen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { VeranstaltungsTypFeldRequest } from '../model/veranstaltungsTypFeldRequest';
// @ts-ignore
import { VeranstaltungsTypIdArrayRequest } from '../model/veranstaltungsTypIdArrayRequest';
// @ts-ignore
import { VeranstaltungsTypIdRequest } from '../model/veranstaltungsTypIdRequest';
// @ts-ignore
import { VeranstaltungsTypIdentifier } from '../model/veranstaltungsTypIdentifier';
// @ts-ignore
import { VeranstaltungsTypRolleMultiRequest } from '../model/veranstaltungsTypRolleMultiRequest';
// @ts-ignore
import { VeranstaltungsTypRolleRequest } from '../model/veranstaltungsTypRolleRequest';
// @ts-ignore
import { VeranstaltungsTypStammRequest } from '../model/veranstaltungsTypStammRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class VeranstaltungsTypenCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostVeranstaltungsTypAdminRolleEntfernen
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/vtyp/command/v1/rollen/admin/entfernen
     * @param veranstaltungsTypRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypAdminRolleEntfernen(veranstaltungsTypRolleRequest: VeranstaltungsTypRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypAdminRolleEntfernen(veranstaltungsTypRolleRequest: VeranstaltungsTypRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAdminRolleEntfernen(veranstaltungsTypRolleRequest: VeranstaltungsTypRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAdminRolleEntfernen(veranstaltungsTypRolleRequest: VeranstaltungsTypRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypRolleRequest === null || veranstaltungsTypRolleRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypRolleRequest was null or undefined when calling postVeranstaltungsTypAdminRolleEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/rollen/admin/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypAdminRollenHinzufuegen
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/vtyp/command/v1/rollen/admin/hinzufuegen
     * @param veranstaltungsTypRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypAdminRollenHinzufuegen(veranstaltungsTypRolleMultiRequest: VeranstaltungsTypRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypAdminRollenHinzufuegen(veranstaltungsTypRolleMultiRequest: VeranstaltungsTypRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAdminRollenHinzufuegen(veranstaltungsTypRolleMultiRequest: VeranstaltungsTypRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAdminRollenHinzufuegen(veranstaltungsTypRolleMultiRequest: VeranstaltungsTypRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypRolleMultiRequest === null || veranstaltungsTypRolleMultiRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypRolleMultiRequest was null or undefined when calling postVeranstaltungsTypAdminRollenHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/rollen/admin/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypAktualisieren
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinVerTypAdmin: (VerTypKeinTypAdmin) 
     * @endpoint post /api/vtyp/command/v1/aktualisieren
     * @param veranstaltungsTypStammRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypAktualisieren(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypAktualisieren(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAktualisieren(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAktualisieren(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypStammRequest === null || veranstaltungsTypStammRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypStammRequest was null or undefined when calling postVeranstaltungsTypAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypStammRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypAnlegen
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/vtyp/command/v1/anlegen
     * @param veranstaltungsTypStammRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypAnlegen(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypAnlegen(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAnlegen(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypAnlegen(veranstaltungsTypStammRequest: VeranstaltungsTypStammRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypStammRequest === null || veranstaltungsTypStammRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypStammRequest was null or undefined when calling postVeranstaltungsTypAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypStammRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypEntfernen
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/vtyp/command/v1/entfernen
     * @param veranstaltungsTypIdRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypEntfernen(veranstaltungsTypIdRequest: VeranstaltungsTypIdRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypEntfernen(veranstaltungsTypIdRequest: VeranstaltungsTypIdRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypEntfernen(veranstaltungsTypIdRequest: VeranstaltungsTypIdRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypEntfernen(veranstaltungsTypIdRequest: VeranstaltungsTypIdRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypIdRequest === null || veranstaltungsTypIdRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypIdRequest was null or undefined when calling postVeranstaltungsTypEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypIdRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypFeldAktualisieren
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinVerTypAdmin: (VerTypKeinTypAdmin) 
     * @endpoint post /api/vtyp/command/v1/feld/aktualisieren
     * @param veranstaltungsTypFeldRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypFeldAktualisieren(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypFeldAktualisieren(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFeldAktualisieren(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFeldAktualisieren(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypFeldRequest === null || veranstaltungsTypFeldRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypFeldRequest was null or undefined when calling postVeranstaltungsTypFeldAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/feld/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypFeldRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypFeldAnlegen
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinVerTypAdmin: (VerTypKeinTypAdmin) 
     * @endpoint post /api/vtyp/command/v1/feld/anlegen
     * @param veranstaltungsTypFeldRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypFeldAnlegen(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypFeldAnlegen(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFeldAnlegen(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFeldAnlegen(veranstaltungsTypFeldRequest: VeranstaltungsTypFeldRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypFeldRequest === null || veranstaltungsTypFeldRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypFeldRequest was null or undefined when calling postVeranstaltungsTypFeldAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/feld/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypFeldRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostVeranstaltungsTypFelderSortieren
     * Problem Types: * VerTypNichtGefunden: (VerTypFunktionsbereichNichtGefunden) * VerTypGeloescht: (VerTypFunktionsbereichGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * KeinVerTypAdmin: (VerTypKeinTypAdmin) 
     * @endpoint post /api/vtyp/command/v1/felder/sortieren
     * @param veranstaltungsTypIdArrayRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postVeranstaltungsTypFelderSortieren(veranstaltungsTypIdArrayRequest: VeranstaltungsTypIdArrayRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungsTypIdentifier>;
    public postVeranstaltungsTypFelderSortieren(veranstaltungsTypIdArrayRequest: VeranstaltungsTypIdArrayRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFelderSortieren(veranstaltungsTypIdArrayRequest: VeranstaltungsTypIdArrayRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungsTypIdentifier>>;
    public postVeranstaltungsTypFelderSortieren(veranstaltungsTypIdArrayRequest: VeranstaltungsTypIdArrayRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungsTypIdArrayRequest === null || veranstaltungsTypIdArrayRequest === undefined) {
            throw new Error('Required parameter veranstaltungsTypIdArrayRequest was null or undefined when calling postVeranstaltungsTypFelderSortieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vtyp/command/v1/felder/sortieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungsTypIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: veranstaltungsTypIdArrayRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
